module.exports = __webpack_public_path__ + "img/title-02.876d7058.png";